<template>
  <v-navigation-drawer app left permanent>
    <logo color="white" horizontal></logo>

    <ul>
      <template v-for="(link, index) in links">
        <li>
          <router-link v-if="link.to"
            class="default-btn nav text"
            :class="[link.subtext ? 'subtext' : '', link.to.name]"
            :to="link.to"
            exact>
            <span v-if="link.subtext">{{ link.subtext }}</span>
            {{ link.text }}
          </router-link>

          <button v-else
            class="default-btn nav text"
            :class="[link.name || '']"
            @click="toggleNavList(index)">
            {{ link.text }}
            <template v-if="link.children">
              <v-icon :class="{ rotate: displayChildren[index] }">mdi-chevron-right</v-icon>
            </template>
          </button>
        </li>

        <template v-if="link.children && displayChildren[index]">
          <li v-for="child in link.children">
            <div v-if="child.indicator" class="indicator" :class="[child.indicator]" />

            <router-link
              v-if="child.to"
              class="default-btn nav text nested"
              :class="[child.subtext ? 'subtext' : '']"
              :to="child.to"
              exact>
              <span v-if="child.subtext">{{ child.subtext }}</span>
              {{ child.text }}
              <span v-if="child.draft" class="help">(Draft)</span>
            </router-link>

            <button
              v-if="child.click"
              class="default-btn nav text nested"
              :class="[child.subtext ? 'subtext' : '']"
              @click="child.click">
              <span v-if="child.subtext">{{ child.subtext }}</span>
              {{ child.text }}
              <span v-if="child.draft" class="help">(Draft)</span>
            </button>
          </li>
        </template>

      </template>

      <li>
        <button
          v-if="userData"
          class="default-btn nav text"
          @click="onLogout">Log Out</button>
      </li>

      <li>
        <router-link
          v-if="section === 'organization' && userData.role === 'admin'"
          class="default-btn nav text mt-3"
          :to="{ name: 'AdminDashboard' }">
          <v-icon size="20" class="mr-1">mdi mdi-flip-h mdi-exit-to-app</v-icon>
          Back to SRG Admin
        </router-link>
      </li>

      <li>
        <router-link
          v-if="section === 'organization' && userData.role === 'lender'"
          class="default-btn nav text mt-3"
          :to="{ name: 'Home' }">
          <v-icon size="20" class="mr-1">mdi mdi-flip-h mdi-exit-to-app</v-icon>
          Back to LendingWell
        </router-link>
      </li>
    </ul>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'Sidebar',
  props: {
    links: {
      type: Array,
      default: () => [],
    },
    section: {
      type: String,
      default: 'admin',
    },
    opened: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    displayChildren: {},
  }),

  computed: {
    ...mapState('authStore', {
      userData: 'userData',
    }),
  },

  methods: {
    ...mapActions('feathers', ['logout']),
    ...mapMutations('authStore', ['CLEAR_USER_DATA']),

    async onLogout () {
      await this.logout()
      this.CLEAR_USER_DATA()
      this.$router.push({ name: 'Home' })
    },

    toggleNavList (index) {
      this.$set(this.displayChildren, index, !this.displayChildren[index])
    },
  },
}
</script>

<style lang="scss" scoped>
.v-navigation-drawer {
  width: 250px !important;
  padding: 30px 0;

  background-color: $accentBlue;

  .logo-container {
    padding: 0 10px;
  }

  ul {
    margin: 30px 0 0;
    padding: 0;
    list-style: none;

    li {
      padding: 1px 0;
      position: relative;

      span {
        font-family: "Sansation Bold", sans-serif;
        font-size: 10px;
        letter-spacing: 0.2px;
        margin-top: -2px;
        margin-bottom: -8px;
        padding-left: 2px;
        text-transform: uppercase;
      }

      .default-btn {
        width: 100%;
        margin: 0;
        padding: 0;
        padding-left: 40px;
        padding-right: 5px;

        justify-content: flex-start;
        text-align: left;

        &.nested {
          font-size: 15px;
          line-height: 17px;
          padding-left: 50px;
        }

        &:hover, &.router-link-exact-active {
          background-color: $accentBlueHover !important;
        }

        &.subtext {
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
        }

        .help {
          padding-left: 5px;
          padding-bottom: 5px;
          color: white;
          font-family: "Sansation Regular", sans-serif;
          font-size: 10px;
        }
      }
    }
  }
}

.v-icon {
  transition-duration: 0.3s !important;
  transition-property: transform !important;

  &.rotate { transform: rotate(90deg); }
}

.indicator {
  position: absolute;
  left: 30px;
  top: 15px;

  width: 10px;
  height: 10px;
  border-radius: 50%;

  &.green {
    background-color: $primaryGreen !important;
    border-color: $primaryGreen !important;
  }

  &.yellow {
    background-color: $primaryYellow !important;
    border-color: $primaryYellow !important;
  }
}
</style>
